import { render, staticRenderFns } from "./booleanIcon.vue?vue&type=template&id=3561e27d&"
import script from "./booleanIcon.vue?vue&type=script&lang=ts&"
export * from "./booleanIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports